import { createSelector } from 'reselect';

const getAppData = (state) => state.app || {};

export const hasInitialized = createSelector([getAppData], (app) => app.hasInitialized);

export const getMessages = createSelector([getAppData], (app) => {
  const messages = app.messages || [];
  return messages.map((message) => {
    const ca = message.caCodes || {};

    return {
      header: message.header,
      message: message.message,
      program: ca.program,
      id: ca.id,
      key: `${ca.id || 'na'}_${ca.program || 'na'}`,
    };
  });
});

export const isFetching = createSelector([getAppData], (app) => app.isFetching);

export const showLoading = createSelector([getAppData], (app) => app.showLoading);

export const hasMoreFlights = createSelector([getAppData], (app) => {
  return app.pageInfo?.hasNextPage || false;
});
